module.exports = __webpack_public_path__ + "static/media/1.20.6833ce7b.png";